import { render } from "./MsisdnClassEditor.vue?vue&type=template&id=17009d9c"
import script from "./MsisdnClassEditor.vue?vue&type=script&lang=js"
export * from "./MsisdnClassEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__